export function isEnum(value: any, entity: Record<string | number, string | number>) {
  const enumValues = Object.keys(entity).map(k => entity[k]);
  return enumValues.indexOf(value) >= 0;
}
